export const PetitionStatus: { [key: number]: string } = {
    1: 'Creada',
    2: 'Recibida por el CCO',
    3: 'Operadores en vía',
    4: 'Operadores en el sitio',
    5: 'Culminada',
};
